import React from 'react';

import Button from '@atlaskit/button/standard-button';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import Tooltip from '@atlaskit/tooltip';

import { DashboardContext } from '@qality/common-pages/src/Dashboard/DashboardProvider';

export const HelpPanelOpenButton: React.FC = () => {
  const { openOnboardingGadget } = React.useContext(DashboardContext);

  return (
    <Tooltip content='Open quick start panel' position='bottom'>
      <Button
        onClick={openOnboardingGadget}
        appearance='subtle'
        iconBefore={
          <QuestionCircleIcon label='Open quick start panel button' />
        }
      />
    </Tooltip>
  );
};
